<template>
  <div class="ic-forms">
    <div v-if="!isSent">
      <div class="row form-group">
        <div class="col-md-12 mbm">{{$t('form_complaint_introtext')}}</div>
        <div class="col-md-4"><label for='form' id='form_label'>{{$t('form_topic')}}</label></div>
        <div class="col-md-8">
          <IcSelect v-model="selected" id="form" :values="formTypeComplaint" :allowEmpty="false"></IcSelect>
        </div>
      </div>
      <component
        v-if="selectedComponent"
        v-bind:is="selectedComponent"
        @form:sent="sent"
        @form:error="error"
      />
    </div>

    <IcFormsSent v-if="isSent" :data="sentData" />
  </div>
</template>
  
<script>
import IcFormsBase from "./Base/FormsBase";
import IcFormComplaintR01 from "./r_01.vue";
import IcFormComplaintR02 from "./r_02.vue";
import IcFormComplaintR02A from "./r_02a.vue";
import IcFormComplaintR03 from "./r_03.vue";
import IcFormComplaintR04 from "./r_04.vue";
import IcFormComplaintR05 from "./r_05.vue";
import IcFormComplaintR06 from "./r_06.vue";
import IcFormComplaintR07 from "./r_07.vue";
import IcFormComplaintR08 from "./r_08.vue";
import IcFormComplaintR09 from "./r_09.vue";
//import IcFormComplaintR10 from "./r_10.vue";
import moment from "moment";
import { get } from "lodash";

const _ = { get };

export default {
  name: "IcFormsComplaint",
  extends: IcFormsBase,
  data() {
    return {
      minDate: moment()
        .add(-1, "years")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      group: "Complaint",
      selected: ""
    };
  },
  methods: {
    checkHash() {
      const hash = window.location.hash.slice(1); // Pobierz wartość po #
      const matchingItem = this.formTypeComplaint.find(item => item.value === hash); // Znajdź obiekt z pasującą wartością
      if (matchingItem ) {
        this.selected = hash;
      }
    }
  },    
  mounted() {
    
    let setup = typeof icVSetup !== "undefined" ? icVSetup : {};
       
    let selected = _.get(setup, "complaint.selected");

    this.selected = typeof selected !== "undefined" ? selected : "";
    this.checkHash(); // Wywołanie przy załadowaniu komponentu
  },
  components: {
    IcFormComplaintR01,
    IcFormComplaintR02,
    IcFormComplaintR02A,
    IcFormComplaintR03,
    IcFormComplaintR04,
    IcFormComplaintR05,
    IcFormComplaintR06,
    IcFormComplaintR07,
    IcFormComplaintR08,
    IcFormComplaintR09,
    //IcFormComplaintR10
  }
};
</script>

<style lang="scss">
</style>
